import { useContext } from 'react';
import { EditorStateContext } from 'components/Product/MultiStep/Contexts';
import { EditorStateContextValues } from 'components/Product/MultiStep/Contexts/EditorStateContext';

const useEditorState = (): EditorStateContextValues => {
  return useContext(EditorStateContext);
};

export default useEditorState;
